module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect1"
  }, [_c('a', {
    attrs: {
      "id": "pV"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/maps.htm#maps"
    }
  }, [_c('i', [_vm._v("List of Maps and Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/note_on_the_text.htm#text"
    }
  }, [_c('i', [_vm._v("Note on the Text")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements.htm#ack"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction.htm#intro"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch1.htm#ch1"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 1")]), _vm._v("Holy War?")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch2.htm#ch2"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 2")]), _vm._v("Young Turks")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch3.htm#ch3"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 3")]), _vm._v("Little Mehmet")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch4.htm#ch4"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 4")]), _vm._v("For Sultan and Caliph")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch5.htm#ch5"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 5")]), _vm._v("Sinai Bridgehead")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch6.htm#ch6"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 6")]), _vm._v("The Battle of Romani")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch7.htm#ch7"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 7")]), _vm._v("The Arab Revolt")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch8.htm#ch8"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 8")]), _vm._v("A Crusader, an Unknown Desert and a New Way of War")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch9.htm#ch9"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v(" 9")]), _vm._v("The Gates of Palestine")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch10.htm#ch10"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("10")]), _vm._v("Aqaba")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch11.htm#ch11"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("11")]), _vm._v("Bull Loose")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch12.htm#ch12"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("12")]), _vm._v("The Railway War")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch13.htm#ch13"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("13")]), _vm._v("The Third Battle of Gaza")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch14.htm#ch14"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("14")]), _vm._v("Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch15.htm#ch15"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("15")]), _vm._v("The Mountains of Moab")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch16.htm#ch16"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("16")]), _vm._v("Special Operations")])]), _vm._v(" "), _c('p', {
    staticClass: "content-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/ch17.htm#ch17"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("17")]), _vm._v("Armageddon")])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/epilogue.htm#epilogue"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/endnotes.htm#endnotes"
    }
  }, [_c('i', [_vm._v("Endnotes")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/timeline.htm#timeline"
    }
  }, [_c('i', [_vm._v("Timeline")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm#biblio"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#index"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0